import React, { useState, useEffect } from 'react';
import { Link as Anchor } from 'react-router-dom';
import LoginUsuario from '../LoginUsuario/LoginUsuario';
import RegisterUsuario from '../RegisterUsuario/RegisterUsuario';
import './AuthUsuario.css';
import user from '../../images/user.png';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faUser, faTimes } from '@fortawesome/free-solid-svg-icons';
import InfoUserMain from '../Admin/InfoUserMain/InfoUserMain';
import baseURL from '../url';
import Spiner from '../Admin/Spiner/Spiner';

export default function AuthUsuario() {
    const [modalContent, setModalContent] = useState('login');
    const [isOpen, setIsOpen] = useState(false);
    const [usuario, setUsuario] = useState({});
    const [loading, setLoading] = useState(true);

    const openModal = () => {
        setModalContent('login');
        setIsOpen(true);
    };

    useEffect(() => {
        const handleOpenAuth = (e) => {
            if (e.defaultPrevented) return;
            e.preventDefault();
            const tab = e?.detail?.tab || 'register';
            setModalContent(tab);
            setIsOpen(true);
        };
        window.addEventListener('open-auth-modal', handleOpenAuth);
        return () => {
            window.removeEventListener('open-auth-modal', handleOpenAuth);
        };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${baseURL}/userLogued.php`, {
                    credentials: 'include'
                });
                if (response.ok) {
                    const data = await response.json();
                    if (data && data.idUsuario) {
                        setUsuario(data);
                        setLoading(false);
                        return;
                    }
                }
            } catch (error) {
                console.error('Error al obtener datos:', error);
            }

            const localUser = localStorage.getItem('usuario');
            if (localUser) {
                try {
                    setUsuario(JSON.parse(localUser));
                } catch (e) {
                    setUsuario({});
                }
            }
            setLoading(false);
        };

        fetchData();
    }, [isOpen]);

    return (
        <div className='AuthContainerClient'>
            <button onClick={openModal} className='authButton'>
                <FontAwesomeIcon icon={faUser} /><strong> Mi cuenta</strong>
            </button>

            <Modal
                isOpen={isOpen}
                onRequestClose={() => setIsOpen(false)}
                className="modalAuth"
                overlayClassName="overlayAuth"
            >
                <div className="modalAuth-content">
                    <div className='deFlexModal'>
                        <span onClick={() => setIsOpen(false)} className="closeModal" title="Cerrar panel">
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </span>
                        <h3>Mi cuenta</h3>
                        <span onClick={() => setIsOpen(false)} className="closeModalAlt" title="Cerrar panel">
                            <FontAwesomeIcon icon={faTimes} />
                        </span>
                    </div>

                    {loading ? (
                        <div className='auth-loading-wrap'>
                            <Spiner />
                        </div>
                    ) : (usuario?.idUsuario && modalContent !== 'register') ? (
                        <InfoUserMain usuario={usuario} onClose={() => setIsOpen(false)} />
                    ) : (
                        <>
                            <Anchor to={`/`}>
                                <img src={user} alt="imagen" className='logoAtuh' />
                            </Anchor>
                            <div className='authButtons'>
                                <button
                                    onClick={() => setModalContent('login')}
                                    className={`authButtonModal ${modalContent === 'login' ? 'selected' : ''}`}
                                >
                                    Ingresar
                                </button>
                                <button
                                    onClick={() => setModalContent('register')}
                                    className={`authButtonModal ${modalContent === 'register' ? 'selected' : ''}`}
                                >
                                    Registrarse
                                </button>
                            </div>
                            {modalContent === 'login' ? (
                                <LoginUsuario />
                            ) : (
                                <RegisterUsuario onSwitchToLogin={() => setModalContent('login')} />
                            )}
                        </>
                    )}
                </div>
            </Modal>
        </div>
    );
}

